import apiSlice from "./ApiSlice";

export const resourceApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    // ADD
    addTeamResource: builder.mutation({
      invalidatesTags: ["teamResources"],
      query: (body) => {
        return {
          url: "/team-resource/add",
          method: "POST",
          body,
        };
      },
    }),
    // Get Team Resources
    getTeamResources: builder.query({
      providesTags: ["teamResources"],
      query: (body) => {
        return {
          url: '/team-resource',
          method: 'POST',
          body,
        };
      },
    }),
    // Delete Resource
    deleteTeamResource: builder.mutation({
      invalidatesTags: ["teamResources"],
      query: ({Id}) => {
        return {
          url: `/team-resource/${Id}`,
          method: 'DELETE',
        };
      },
    }),
    // Update Resource
    updateTeamResource: builder.mutation({
      invalidatesTags: ["teamResources"],
      query: ({body,id}) => {
        return {
          url: `/team-resource/${id}`,
          method: 'PUT',
          body,
        };
      },
    }),
    // get Resource
    getTeamResource: builder.query({
      providesTags: ["teamResources"],
      query: (id) => {
        return {
          url: `/team-resource/${id}`,
          method: 'GET',
        };
      },
    }),
  }),
});

export const {
  useAddTeamResourceMutation,
  useGetTeamResourcesQuery,
  useDeleteTeamResourceMutation,
  useGetTeamResourceQuery,
  useUpdateTeamResourceMutation 
} = resourceApi;
